import {
  FETCH,
  DONE,
  FAIL,
  PROFILE,
  AUTH, GET, MENU, NOTIFICATION, SET,
  ENTRANT_VERIFICATION_CODE, ENTRANT_REGISTER, RESET
} from "../../constants";

import reducerStatuses from "../../status";
import {createReducer, PayloadAction} from "@reduxjs/toolkit";
import {TFetch} from "../../types";

const initialState: TFetch = {
  userProfile: {
    ...reducerStatuses,
    data: {} as any,
  },
  menu: {
    ...reducerStatuses,
    data: [],
  },
  notification: {
    ...reducerStatuses,
    data: [],
  },

  //entrant
  verificationCode: {
    ...reducerStatuses,
    data: null
  },
  registerData: {
    ...reducerStatuses,
    data: null
  },
};

export default createReducer(initialState, builder =>
  builder
    .addCase(AUTH + FETCH, (state) => ({
      ...state,
      userProfile: {
        ...initialState.userProfile,
        loading: true
      }
    }))
    .addCase(AUTH + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      userProfile: {
        ...initialState.userProfile,
        success: true,
        data: payload
      }
    }))
    .addCase(AUTH + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      userProfile: {
        ...initialState.userProfile,
        failed: true
      }
    }))


    .addCase(PROFILE + FETCH, (state) => ({
      ...state,
      userProfile: {
        ...initialState.userProfile,
        loading: true
      }
    }))
    .addCase(PROFILE + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      userProfile: {
        ...initialState.userProfile,
        success: true,
        data: payload
      }
    }))
    .addCase(PROFILE + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      userProfile: {
        ...initialState.userProfile,
        failed: true
      }
    }))

    .addCase(GET + MENU + FETCH, (state) => ({
      ...state,
      menu: {
        ...initialState.menu,
        loading: true
      }
    }))
    .addCase(GET + MENU + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      menu: {
        ...initialState.menu,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + MENU + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      menu: {
        ...initialState.menu,
        failed: true
      }
    }))

    .addCase(GET + NOTIFICATION + FETCH, (state) => ({
      ...state,
      notification: {
        ...state.notification,
        loading: true
      }
    }))
    .addCase(GET + NOTIFICATION + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      notification: {
        ...state.notification,
        loading: false,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + NOTIFICATION + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      notification: {
        ...state.notification,
        loading: false,
        success: false,
        failed: true
      }
    }))

    .addCase(SET + NOTIFICATION + FETCH, (state) => ({
      ...state,
      notification: {
        ...state.notification,
        loading: true
      }
    }))
    .addCase(SET + NOTIFICATION + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      notification: {
        ...state.notification,
        loading: false,
        success: true,
        data: []
      }
    }))
    .addCase(SET + NOTIFICATION + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      notification: {
        ...state.notification,
        loading: false,
        success: false,
        failed: true
      }
    }))

    //entrant
    .addCase(ENTRANT_VERIFICATION_CODE + FETCH, (state) => ({
      ...state,
      verificationCode: {
        ...state.verificationCode,
        loading: true,
        success: false,
        failed: false
      }
    }))
    .addCase(ENTRANT_VERIFICATION_CODE + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      verificationCode: {
        ...state.verificationCode,
        loading: false,
        success: true,
        failed: false,
        data: payload
      }
    }))
    .addCase(ENTRANT_VERIFICATION_CODE + FETCH + FAIL, (state) => ({
      ...state,
      verificationCode: {
        ...state.verificationCode,
        loading: false,
        success: false,
        failed: true
      }
    }))
    .addCase(ENTRANT_VERIFICATION_CODE + RESET, (state) => ({
      ...state,
      verificationCode: {
        ...state.verificationCode,
        loading: false,
        success: false,
        failed: false,
        data: null
      }
    }))
    .addCase(ENTRANT_REGISTER + FETCH, (state) => ({
      ...state,
      registerData: {
        ...state.registerData,
        loading: true,
        success: false,
        failed: false
      }
    }))
    .addCase(ENTRANT_REGISTER + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      registerData: {
        ...state.registerData,
        loading: false,
        success: true,
        failed: false,
        data: payload
      }
    }))
    .addCase(ENTRANT_REGISTER + FETCH + FAIL, (state) => ({
      ...state,
      registerData: {
        ...state.registerData,
        loading: false,
        success: false,
        failed: true
      }
    }))
    .addCase(ENTRANT_REGISTER + RESET, (state) => ({
      ...state,
      registerData: {
        ...state.registerData,
        loading: false,
        success: false,
        failed: false,
        data: null
      }
    }))
)